/* unplugin-vue-components disabled */import script from "./member-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./member-modal.vue?vue&type=script&setup=true&lang=js"

import "./member-modal.vue?vue&type=style&index=0&id=7dd32f18&lang=scss"

const __exports__ = script;

export default __exports__